const noOp = () => {};

let lifecycle = {
  onFreshLogin: noOp,
  onSessionCleared: noOp,
  resolvePostLoginRedirect: () => "",
};

/**
 * Register optional product-specific browser-state cleanup and redirects.
 *
 * Core owns authentication but does not know either product's local-storage
 * keys or OAuth return paths. The neutral entrypoint supplies enabled product
 * behavior once at startup.
 *
 * @param {Object} nextLifecycle Product callbacks.
 * @returns {void}
 * @example
 * configureAuthLifecycle({ onFreshLogin: () => localStorage.removeItem("tour") });
 * // Subsequent notifyFreshLogin() calls the registered callback.
 */
export const configureAuthLifecycle = (nextLifecycle = {}) => {
  lifecycle = {
    onFreshLogin: nextLifecycle.onFreshLogin || noOp,
    onSessionCleared: nextLifecycle.onSessionCleared || noOp,
    resolvePostLoginRedirect:
      nextLifecycle.resolvePostLoginRedirect || (() => ""),
  };
};

/** Notify enabled products that a fresh login completed. */
export const notifyFreshLogin = () => lifecycle.onFreshLogin();

/** Notify enabled products that the local user session was cleared. */
export const notifySessionCleared = () => lifecycle.onSessionCleared();

/**
 * Resolve a product-specific post-login redirect.
 *
 * @param {string} search Current location search.
 * @returns {string} Relative path or an empty string.
 * @example
 * resolvePostLoginRedirect("?code=x&state=performer_gmail");
 * // "/business/action-items" when the mantis lifecycle resolves that state.
 */
export const resolvePostLoginRedirect = (search = "") =>
  lifecycle.resolvePostLoginRedirect(search) || "";
